import i18n from "@/common/multilanguage/i18n";
import { getCurrentSubdomain } from "@/common/functions";
import BrowseLink from "@/components/BrowseByIndexPanel/BrowseLink/BrowseLink.vue";

export default {
	components: {
		BrowseLink
	},
	props: {
		labels: {
			type: Object || Array,
			default: () => {
				const keyboard = {
					sentence: {
						en: [
							"#",
							"a",
							"b",
							"c",
							"d",
							"e",
							"f",
							"g",
							"h",
							"i",
							"j",
							"k",
							"l",
							"m",
							"n",
							"o",
							"p",
							"q",
							"r",
							"s",
							"t",
							"u",
							"v",
							"w",
							"x",
							"y",
							"z"
						],
						es: [
							"#",
							"a",
							"b",
							"c",
							"d",
							"e",
							"f",
							"g",
							"h",
							"i",
							"j",
							"k",
							"l",
							"m",
							"n",
							"ñ",
							"o",
							"p",
							"q",
							"r",
							"s",
							"t",
							"u",
							"v",
							"w",
							"x",
							"y",
							"z"
						]
					},
					thesaurus: {
						en: [
							"a",
							"b",
							"c",
							"d",
							"e",
							"f",
							"g",
							"h",
							"i",
							"j",
							"k",
							"l",
							"m",
							"n",
							"o",
							"p",
							"q",
							"r",
							"s",
							"t",
							"u",
							"v",
							"w",
							"x",
							"y",
							"z"
						],
						es: [
							"a",
							"b",
							"c",
							"d",
							"e",
							"f",
							"g",
							"h",
							"i",
							"j",
							"k",
							"l",
							"m",
							"n",
							"ñ",
							"o",
							"p",
							"q",
							"r",
							"s",
							"t",
							"u",
							"v",
							"w",
							"x",
							"y",
							"z"
						]
					}
				};

				return keyboard[getCurrentSubdomain()];
			}
		},
		processing: Boolean
	},
	data() {
		return {
			currentLocale: i18n.locale
		};
	}
};



// WEBPACK FOOTER //
// ./src/components/BrowseByIndexPanel/BrowsePanel/BrowsePanel.js